import { createReducer, on } from '@ngrx/store';

import { PlaybookActions } from './playbook.actions';
import { PlaybookState } from './playbook.models';

export const initialPlaybookState: PlaybookState = {
    StartIndex: 0,
    EndIndex: 6,
    PageSize: 7,
};

export const playbookReducer = createReducer(
    initialPlaybookState,
    on(PlaybookActions.setPageSize, (state, { pageSize }): PlaybookState => {
        return { ...state, PageSize: pageSize };
    }),
    on(PlaybookActions.setStartIndex, (state, { startIndex }): PlaybookState => {
        return { ...state, StartIndex: startIndex, EndIndex: startIndex + state.PageSize - 1 };
    })
);
